module.exports = __webpack_public_path__ + "img/invite_desc_bg.9abd3250.svg";